export default function ErrorPage() {
  return <h1>Error 404!</h1>
}
